import React from 'react';
import { Container, Paper, Typography, Box, Grid, Divider } from '@mui/material';
import { Phone, WhatsApp, Email, LocationOn, AccessTime } from '@mui/icons-material';

function Contact() {
  return (
    <Container maxWidth="md" sx={{ py: { xs: 4, md: 8 }, mt: { xs: '56px', sm: '64px' } }}>
      <Paper elevation={0} sx={{ p: { xs: 3, md: 6 }, backgroundColor: '#f8f8f8', borderRadius: 2 }}>
        <Typography 
          variant="h4" 
          component="h1" 
          align="center"
          sx={{ mb: 4, fontWeight: 600, color: 'primary.main' }}
        >
          Bize Ulaşın
        </Typography>

        <Divider sx={{ mb: 4 }} />

        <Grid container spacing={4}>
          {/* İletişim Bilgileri */}
          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Phone color="primary" />
                <Box>
                  <Typography variant="subtitle1" fontWeight="bold">Telefon</Typography>
                  <Typography>+90 531 694 97 44</Typography>
                </Box>
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <WhatsApp color="primary" />
                <Box>
                  <Typography variant="subtitle1" fontWeight="bold">WhatsApp</Typography>
                  <Typography>+90 531 694 97 44</Typography>
                </Box>
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Email color="primary" />
                <Box>
                  <Typography variant="subtitle1" fontWeight="bold">E-posta</Typography>
                  <Typography>info@kaylabutik.com</Typography>
                </Box>
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                <LocationOn color="primary" />
                <Box>
                  <Typography variant="subtitle1" fontWeight="bold">Adres</Typography>
                  <Typography>
                  Ergenekon caddesi No/55/B nazar pasajı 
                    <br />
                    Şişli/İstanbul
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>

          {/* Çalışma Saatleri */}
          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <AccessTime color="primary" />
                <Box>
                  <Typography variant="subtitle1" fontWeight="bold">Çalışma Saatleri</Typography>
                  <Typography>Hafta içi: 09:00 - 18:00</Typography>
                  <Typography>Cumartesi: 10:00 - 16:00</Typography>
                  <Typography>Pazar: Kapalı</Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
}

export default Contact; 